import { routes } from "constants/projectRoutes";
import { versionSettings } from "constants/version";
import { cloneDeep, isNil } from "lodash";

export const getProjectCompletion = (project) => {
  const settings = getVersionSettings(project);
  const table_count = settings.table_count || 41;
  return Math.round((project?.data_completion_count / table_count) * 100) || 0;
};

export const isInputInTable = (menu, project) => {
  if (!project) return false;
  let value = true;
  menu?.children
    ?.filter((it) => !it.noInput)
    .forEach((it) => {
      if (!it.inputKey) return;
      value = value && !isNil(project[it.inputKey]);
    });
  return value;
};

export const isInputStarted = (menu, project) => {
  if (!project) return false;
  let value = false;
  menu?.children?.forEach((it) => {
    value = value || project[it.inputKey];
  });
  return value;
};

export const getDownloadTitle = (list) =>
  list.length > 0 ? "Download Dataset" : "Download Template";

export const getVersionSettings = (project) => {
  const ver = project?.usim_image_version ?? "1.0";
  return versionSettings[ver];
};

export const getVersionWiseRoutes = (project) => {
  const settings = getVersionSettings(project);

  const cRoutes = cloneDeep(routes);

  return cRoutes.map((menuItem) => {
    const hideItem = settings?.hide_table?.find(
      (h) => h.route === menuItem.route
    );

    if (hideItem) {
      menuItem.children = menuItem.children.filter(
        (child) => !hideItem.children.includes(child.inputKey)
      );
    }

    return menuItem;
  });
};

export const getVersionWiseColumns = (route, columns, project) => {
  const settings = getVersionSettings(project);

  const hideColumnsItem = settings?.hide_columns?.find(
    (h) => h.route === route
  );

  if (!hideColumnsItem) {
    return columns;
  }

  const cColumns = cloneDeep(columns);

  return cColumns.filter(
    (item) => !hideColumnsItem.columns.includes(item.field)
  );
};
